import axios from 'axios';
import { REST_HOSTNAME } from '../Config';

export interface PilotRequest {
    name: string;
    email: string;
    organization: string;
    language: string;
    message: string;
    website: string;
}

export const PilotRequestApi = {
    send(request: PilotRequest) {
        return axios.post<string>(`${REST_HOSTNAME}/pilot_request`, request);
    },
};
